<template>
  <div class="col-md-10 ml-sm-auto pt-3 px-4">
    <div class="row">
      <div class="col-md-12 text-start">
        <h5 class="bold d-inline-block">
          Orders -
          {{ ordersStore.showAllOrders === false ? "6 months" : "All" }}
        </h5>
        <span v-if="!isLoading && orders" class="small text-muted"
          >&nbsp;({{ orders.length }})</span
        >
        <span v-else class="small">&nbsp;Loading...</span>
        <button
          type="button"
          class="btn btn-primary float-end"
          :disabled="isLoading === true"
          @click="toggleGetOrders"
        >
          {{
            ordersStore.showAllOrders === false
              ? "Fetch all Orders"
              : "Fetch 6 months"
          }}
        </button>
      </div>
    </div>

    <Loading :isLoading="isLoading" />

    <div v-if="!isLoading" class="row">
      <div class="col-md-12 text-start">
        <div class="card p-2">
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="text-start w-25">Order date</th>
                <th class="text-start">Order reference</th>
                <th class="text-start">Project number</th>
                <th class="text-start">Status</th>
                <th class="text-end w-25">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr
                style="cursor: pointer"
                v-for="order in orders"
                :key="order?.orderNumber"
                @click="goToOrderDetails(order)"
              >
                <td class="text-start">
                  {{ getFormattedOrderDate(order?.orderDate) }}
                </td>
                <td class="text-start">
                  {{ order.orderReference && order.orderReference }}
                </td>
                <td class="text-start">
                  {{ order.orderNumber && order.orderNumber }}
                </td>
                <td class="text-start">
                  {{
                    order.orderStatus && getOrderStatusText(order.orderStatus)
                  }}
                </td>
                <td class="text-end">
                  {{
                    formatCurrency(
                      order?.subTotal,
                      userStore.userInfo?.currency
                    )
                  }}
                </td>
              </tr>
              <tr></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import { useUserStore } from "@/store/userStore";
import { GetOrdersRequest, OrderClient, OrdersInfo } from "@/data/client";
import { useOrdersStore } from "@/store/ordersStore";
import Loading from "@/components/shared/Loading.vue";
import { formatCurrency, formatDate } from "@/helpers/HelperTool";
import axios, { Axios } from "axios";
import { msalService } from "@/config/useAuth";
import { msalInstance } from "@/config/msalConfig";

@Component({
  components: { Loading },
})
class OrdersView extends Vue {
  userStore = useUserStore();
  ordersStore = useOrdersStore();
  orderClient = new OrderClient();
  orders: OrdersInfo[] = [];
  isLoading = true;
  show = false;

  async mounted() {
    await this.GetOrders();
  }

  private async GetOrders() {
    if (this.ordersStore.orders?.length === 0) {
      var axiosClient = axios.create();
      await this.initialize(axiosClient);

      const req = new GetOrdersRequest({
        customerAccountNumber: this.userStore.userInfo?.customerAccountNumber,
        accountId: this.userStore.userInfo?.accountId,
        allOrders: this.ordersStore.showAllOrders,
      });

      this.orderClient = new OrderClient(
        process.env.VUE_APP_BACKEND_URI ?? "",
        axiosClient
      );

      this.orderClient.getOrders(req).then((res) => {
        this.ordersStore.setOrders(res);
        this.orders = this.ordersStore.orders;
        this.isLoading = false;
      });
    } else {
      this.orders = this.ordersStore.orders;
      this.isLoading = false;
    }
  }

  async initialize(axiosClient: Axios) {
    try {
      await msalInstance.initialize();
      this.registerAuthorizationHeaderInterceptor(axiosClient);
    } catch (error) {
      console.log("Initialization error", error);
    }
  }

  registerAuthorizationHeaderInterceptor =
    msalService().registerAuthorizationHeaderInterceptor;

  formatCurrency(
    value: number | undefined,
    currency: string | undefined = "USD"
  ): string {
    return formatCurrency(value, currency);
  }

  showHideNew() {
    this.show = !this.show;
  }
  goToOrderDetails(order: OrdersInfo) {
    this.$router.push({
      path: `/orderdetails`,
      query: {
        orderInfo: order.orderNumber ? order.orderNumber : order.orderId,
      },
    });
  }

  toggleGetOrders() {
    this.isLoading = true;
    this.ordersStore.setShowAllOrders(!this.ordersStore.showAllOrders);
    this.ordersStore.emptyOrderStore();
    this.orders = [];
    this.GetOrders();
  }

  getFormattedOrderDate(orderDate: Date | undefined): string {
    if (!orderDate) return "";
    return formatDate(orderDate);
  }

  getOrderStatusText(status: number | undefined): string {
    const statusMap: Record<number, string> = {
      1: "New",
      3: "In Process",
      5: "Cancelled",
      6: "Invoiced",
      7: "On Hold",
      175660002: "Cancelled",
    };

    return status !== undefined ? statusMap[status] ?? "Unknown" : "No status";
  }
}
export default OrdersView;
</script>
